import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { object, omit } from 'underscore';
import {
  Label,
  makeStyles,
  tokens,
  typographyStyles,
} from '@fluentui/react-components';
import { DateRangePicker } from '../date-range-picker';

const useStyles = makeStyles({
  filterItem: {
    display: 'flex',
    flexDirection: 'column',
    gap: tokens.spacingVerticalXS,
  },
  filterItemLabel: {
    fontStyle: 'normal',
    ...typographyStyles.caption1Strong,
    color: '#605E5C',
  },
});

const DateRangeFilterComponent = (props) => {
  const {
    startDate,
    endDate,
    searchParams,
    setSearchParams,
  } = props;
  const classes = useStyles();

  const onPickDateRanges = useCallback((data) => {
    let newSearchParams = object([...searchParams]);
    if (data.rangeType.rangeId === 8) {
      newSearchParams = omit(newSearchParams, 'start', 'end');
    } else {
      newSearchParams.start = data.selectedRange.start.toString();
      newSearchParams.end = data.selectedRange.end.toString();
    }
    setSearchParams(newSearchParams);
  }, [searchParams, setSearchParams]);

  return (
    <div className={classes.filterItem}>
      <Label className={classes.filterItemLabel}>Date</Label>
      <DateRangePicker
        startDate={startDate}
        endDate={endDate}
        onPickDateRanges={onPickDateRanges}
      />
    </div>
  );
};

DateRangeFilterComponent.propTypes = {
  startDate: PropTypes.string,
  endDate: PropTypes.string,
  searchParams: PropTypes.shape({
    get: PropTypes.func,
  }).isRequired,
  setSearchParams: PropTypes.func.isRequired,
};

DateRangeFilterComponent.defaultProps = {
  startDate: '',
  endDate: '',
};

export const DateRangeFilter = DateRangeFilterComponent;
